import type { BetLoopSharedBet } from '@core/Areas/BetLoop/types'
import { isKambiSharedCoupon } from '@core/Areas/BetLoop/helpers/typeGuards/isKambiSharedCoupon'
import { dayjs } from '@mobi/utils/date'
import { getKambiCouponBetType } from '@core/Areas/KambiSports/Player/helpers/getKambiCouponBetType'

export function canBetBeCopied(sharedBet: BetLoopSharedBet): boolean {
  if (sharedBet.isResulted || !sharedBet.canCopyBet) return false

  if (isKambiSharedCoupon(sharedBet.ticket)) {
    const betType = getKambiCouponBetType(sharedBet.ticket)

    if (betType === 'multi') {
      const hasEventsYetToStart = sharedBet.ticket.events.some(event =>
        dayjs().isBefore(event.eventStartDate)
      )
      const hasOpenOutcomes = sharedBet.ticket.outcomes.some(outcome => outcome.status === 'OPEN')
      return hasEventsYetToStart && hasOpenOutcomes
    } else {
      const isPreEventStart = sharedBet.ticket.events.every(event =>
        dayjs().isBefore(event.eventStartDate)
      )
      const areAllOutcomesOpen = sharedBet.ticket.outcomes.every(
        outcome => outcome.status === 'OPEN'
      )
      return isPreEventStart && areAllOutcomesOpen
    }
  }

  return sharedBet.ticket.status === 'Pending'
}
